export default __webpack_public_path__ + "static/media/teamimg.5cbd5977.svg";